import React, { useState, useRef } from "react";
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { motion } from "framer-motion"


const OfferComp = () => {

    const [formData, setFormData] = useState({
        firstName: '',
        email: '',
        phone: '',
        date: '',
        message: '', // Added message field
      });
    
      const [errors, setErrors] = useState({});
      const [isSubmitted, setIsSubmitted] = useState(false);

      const timeRef = useRef();
    
      // Input validation
      const validateInput = () => {
        let newErrors = {};
    
        // Validate first name
        if (!formData.firstName) {
          newErrors.firstName = 'First Name is required';
        } else if (!/^[a-zA-Z\s]+$/.test(formData.firstName)) {
          newErrors.firstName = 'First Name can only contain letters';
        }
    
    
        // Validate email
        if (!formData.email) {
          newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
          newErrors.email = 'Email is not valid';
        }
    
        // Validate phone number
        if (!formData.phone) {
          newErrors.phone = 'Phone number is required';
        } else if (!/^[0-9]{10}$/.test(formData.phone)) {
          newErrors.phone = 'Phone number must be 10 digits';
        }

// Validate date
if (!formData.date) {
  newErrors.date = 'Valid date is required';
} else {
  const dateObj = new Date(formData.date);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set time to midnight for accurate comparison

  const weekDay = dateObj.getUTCDay(); // 0 = Sunday, 6 = Saturday

  if (dateObj < today) {
    newErrors.date = "Date unavailable";
  } else if (weekDay === 0) {
    newErrors.date = "We're closed on Sundays";
  }
}


    //useRef for time
    const appTime = timeRef.current.value
      // Validate message
      if (!appTime) {
        newErrors.time = 'Select a time';
      }

    
        // Validate message
        if (!formData.message) {
          newErrors.message = 'Message is required';
        } else if (formData.message.length < 10) {
          newErrors.message = 'Message must be at least 10 characters long';
        }
    
        return newErrors;
      };

     
      // Handle form submission
      const handleSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission behavior
    
        const validationErrors = validateInput();
    
        if (Object.keys(validationErrors).length === 0) {
          // Sanitize the input data
          const sanitizedData = {
            firstName: DOMPurify.sanitize(formData.firstName),
            email: DOMPurify.sanitize(formData.email),
            phone: DOMPurify.sanitize(formData.phone),
            date: DOMPurify.sanitize(formData.date),
            message: DOMPurify.sanitize(formData.message), // Sanitize message
          };
    
          console.log('Sanitized and validated data:', sanitizedData);
          setIsSubmitted(true);
    
          // Now, allow the form to be submitted to the action URL
          event.target.submit();
        } else {
          setErrors(validationErrors);
        }
      };
    
      // Handle input change
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
    


    return ( 
        <>
    <div className="main_cont fixed-top">
          <nav className=" pe-3 mobile_cont d-none nav_cont">
            <ul>
                <a href="/"><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline" style={{"width":"15%"}}/></a> 
              <div className="d-inline pt-4" style={{"float":"right","letterSpacing":"4px"}}>
              <Link to={"/signup"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center activ_box" > <p className="activ">Free Offer</p></div></Link>
              <Link to={"/"}  className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Home</div></Link>
              <Link to={"/templates"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Websites</div></Link>
              <Link to={"/about"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >About</div></Link>
              <Link to={"/policy"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Policy</div></Link>
              <a href="/" className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Contact</div></a>
              </div>
            </ul>
          </nav>
        

<nav className="mobile_cont d-md-none fixed-top">
<button style={{"background":"none"}} className="btn btn-white ms-3 my-4" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions"><i className="fa fa-bars" style={{"fontSize":"30px"}} aria-hidden="true"></i>
</button> <Link to={'/signin'}><button style={{"background":"none"}} className="btn btn-white" type="button" ><i class="fa fa-phone fw-bold text-success" style={{"fontSize":"30px"}} aria-hidden="true"></i></button></Link>
<a href='#home'><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline mx-5 my-4" style={{"width":"25%", "float":"right","transform":"scale(1.9)"}}/></a>
<div className="offcanvas offcanvas-start w-50" data-bs-scroll="true" tabindex="-1" id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
  <div className="offcanvas-header">
    <h5 className="offcanvas-title" id="offcanvasWithBothOptionsLabel"><Link><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline" style={{"width":"60%", "float":"left","transform":"scale(1.8)"}}/></Link>
</h5>
    <button type="button" className="btn-close btn-danger" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="mob offcanvas-body text-white" style={{ backgroundColor: "#E52020", textAlign: "center" }}>
  <Link to={"/signup"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Offer
    </div>
  </Link>
  <Link to={"/"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Home
    </div>
  </Link>
  <Link to={"/templates"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Websites
    </div>
  </Link>
  <Link to={"/about"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
       About
    </div>
  </Link>
  <Link to="/policy" style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
       Policy
    </div>
  </Link>
  <a href={"#contact"} style={{ textDecoration: "none" }}>
    <div className="a_log w-100 p-3 mt-3 text-white" style={{ fontSize: "20px" }}>
      Contact
    </div>
  </a>
</div>

</div>
</nav>
        </div>


                                                 {/*offer section*/}
<div class="container my-5 pt-4 text-center" id="about">
<i class="fa fa-globe fs-1" aria-hidden="true"style={{color: "#000080"}}></i>
<h3>Claim Your Professional Website</h3>
  <hr className="hr_line"></hr>
  <div class="row g-2 mt-3 border">
    <div class="col-sm-6">
    <div className="text-start">
      <h4>This pro website is guaranteed for lead generation that last for lifetime.</h4>
      <p>Not getting enough customers? Increase sales & revenue with our solution.</p>
   
    <img src="/images/workman.png" class="img-fluid py-5 px-5" style={{height: "100%",width:"100%"}} />
    <p>Here is a solution to all your problems. This website will enhance your sales and revenue by generating leads through search engine optimization. Our strategy is proven to be 100% effective in reaching larger audience to increase income. <span className="text-warning">Schedule an appointment today to receive this offer.</span></p>
   </div>
    </div>
    <div class="col-sm-6 b_cont">
    <div className="text-start" style={{backgroundColor: "#000080"}}>
        <h5 className="fw-bold ms-3 text-light">Book an appointment to get your professional website from carib web works</h5>
        <p className="mb-0 ms-3 text-light">Fill out all required fields</p>
        <div className="w-100">
          <form onSubmit={handleSubmit} className="p-3" style={{ margin: 'auto' }} action="https://formsubmit.co/caribwebworks@gmail.com" method="POST" >
            <div className="mb-3" style={{ textAlign: 'center' }}>
              <img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline" style={{ width: '30%', transform: 'scale(1.2)', margin: 'auto' }} />
            </div>

            <div className="mb-3">
              <input
                type="text"
                name="firstName"
                className="form-control"
                placeholder="Name"
                value={formData.firstName}
                onChange={handleInputChange}
                style={{width:"49%", display:"inline-block",marginRight:"2%"}}
              />
              <input
                type="number"
                name="phone"
                className="form-control"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleInputChange}
                style={{width:"49%", display:"inline-block"}}
              />
             <div className="d-flex justify-content-between">
  {errors.firstName && <div className="text-danger">{errors.firstName}</div>}
  {errors.phone && <div className="text-danger text-end">{errors.phone}</div>}
</div>

            </div>

            <div className="mb-3">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
              />
              {errors.email && <div className="text-danger">{errors.email}</div>}
            </div>

            <div className="mb-3">
              <input
                type="date"
                name="date"
                className="form-control"
                value={formData.date}
                onChange={handleInputChange}
                style={{width:"49%", display:"inline-block",marginRight:"2%"}}
              />
              <select
               ref={timeRef}
               className="form-control"
               style={{width:"49%", display:"inline-block"}}
               name="time"
              >
                <option>10:00AM</option>
                <option>11:00AM</option>
                <option>12:00AM</option>
                <option>1:00PM</option>
                <option>2:00PM</option>
                <option>3:00PM</option>
                <option>4:00PM</option>
                <option>5:00PM</option>
                <option>6:00PM</option>
              </select>
               
                
<div className="d-flex justify-content-between">
  {errors.date && <div className="text-danger">{errors.date}</div>}
  {errors.time && <div className="text-danger text-end">{errors.time}</div>}
</div>

            </div>

            <div className="mb-3">
              <textarea
                name="message"
                className="form-control"
                placeholder="Your Message"
                rows="4"
                value={formData.message}
                onChange={handleInputChange}
              />
              {errors.message && <div className="text-danger">{errors.message}</div>}
            </div>

            <input type="hidden" name="_next" value="https://caribwebworks.com/complete"/>
			  <input type="hidden" name="_captcha" value="false"/>
			  <input type="hidden" name="_template" value="table"/>
            
            <button type="submit" className="btn text-light" style={{ backgroundColor: '#E52020',width:"100%" }}>
              Book Appointment &rarr;
            </button>
            {isSubmitted && <p className="text-success mt-3">Message sent successfully!</p>}
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

                                  {/*Testamonial section*/}
<div class="container text-center my-5">
<i class="fa fa-globe fs-1" aria-hidden="true"style={{color: "#000080"}}></i>
   <h3>Client Reviews</h3>
      <hr className="hr_line"></hr>
        <div class="row section_2row row-cols-4 row-cols-lg-5 g-2 g-lg-3 mt-2">
    <div class="col">
      <div>
      <div style={{"color":"goldenrod"}}>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
   </div>
   <small>"I can't stop seeing profit from ever since we've worked together."</small><br />
   <i>By: James Author</i>
      </div>
    </div>
    <div class="col">
      <div>
      <div style={{"color":"goldenrod"}}>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
   </div>
   <small>"You are the best. You guys take me from 0-100."</small><br />
   <i>By: Tracy Clarke</i>
      </div>
    </div>
    <div class="col">
      <div>
      <div style={{"color":"goldenrod"}}>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
   </div>
   <small>"First I had doubt, but when I saw the results I was literally crying."</small><br />
   <i>By: Marci Wincok Author</i>
      </div>
    </div>
    <div class="col">
      <div>
      <div style={{"color":"goldenrod"}}>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
      <i class="fa fa-star" aria-hidden="true"></i>
   </div>
   <small>"Trust me I owed you alot. Great! Great! Great Job!"</small><br />
   <i>By: Gabriel Smith</i>
      </div>
    </div>
  </div>
</div>                              


                                  {/*footer section*/} 
    <div className="body-footer text-center text-white" id="contact" style={{"backgroundColor":"#E52020"}}>
            <footer className="w-100 py-4 flex-shrink-0">
                <div className="container py-4">
                    <div className="row gy-4 gx-5">
                        <div className="col-lg-4 col-md-6">
                            <h5 className="h1 text-white">Contact Us</h5>
                            <p className="small text-white">Call: (876) 808-9990</p>
                            <p className="small text-white">Watsapp: (876) 808-9990</p>
                            <p className="small text-white">Email: caribwebworks@gmail.com </p>
                            <p className="small text-white">Address: Montego Bay, St. James</p>
                            <p><i class="fa fa-twitter-square me-3" aria-hidden="true"></i> 
                           <i class="fa fa-instagram me-3" aria-hidden="true"></i>
                            <i class="fa fa-facebook-square me-3" aria-hidden="true"></i>
                            </p>   
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <h5 className="text-white mb-3">Menu</h5>
                            <ul className="list-unstyled text-dark">
                                <li><a className="text-warning fw-bold"  href="/">Home</a></li>
                                <li><Link className="text-warning fw-bold"  to={"/about"}>About</Link></li>
                                <li><Link className="text-warning fw-bold"  to={"/policy"}>Policy</Link></li>
                                <li><a className="text-warning fw-bold"  href="/" >FAQ</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <h5 className="text-white mb-3">Menu</h5>
                            <ul className="list-unstyled">
                            <li><a className="text-warning fw-bold"  href="/">Home</a></li>
                                <li><Link className="text-warning fw-bold"  to={"/about"}>About</Link></li>
                                <li><Link className="text-warning fw-bold"  to={"/policy"}>Policy</Link></li>
                                <li><a className="text-warning fw-bold"  href="/" >FAQ</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-6">
                        <h3 className="h1 text-white">Carib Web Works</h3>
                            <img src="/images/business_logo1.png" alt="logo" className="img-fluid d-inline my-2" style={{"width":"40%","transform":"scale(1.2)"}}/>
                            <p className="small" style={{"color":"gold"}}>"Attract more customers with digital marketing"</p>
                            <i>By: Ceo & Team</i>
                        </div>
                    </div>
                </div>
                <p className="small text-dark mb-0" id="contact">&copy; Copyrights. All rights reserved. <a className="text-primary" href="/signup" target={'_blank'}>caribwebworks.com</a></p>
            </footer>
                </div>
        </>
     );
}
 
export default OfferComp;